import { Injectable, OnDestroy } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root'
})
export class BroadcastChannelService implements OnDestroy {
  private channel_name!: string | null;
  private channel!: BroadcastChannel | null;
  private messages$ = new Subject<any>();
  private localMessages$ = new Subject<any>();

  constructor() {
    // this.channel = new BroadcastChannel('');
  }

  connect(channel_name: string | null = null) {
    if (!channel_name) {
      channel_name = environment.websocket.broadcast_channel;
    }
    if (channel_name != this.channel_name || this.channel == null) {
      this.channel_name = channel_name;
      this.channel = new BroadcastChannel(channel_name);

      this.channel.onmessage = (event) => {
        this.messages$.next(event.data);
      };
    }

  }

  sendLocalMessage(message: any) {
    this.messages$.next(message);
  }

  sendMessage(message: any) {
    if(!this.channel) {
      this.connect();
    }
    this.channel?.postMessage(message);
  }

  getMessages(): Observable<any> {
    return this.messages$.asObservable();
  }

  close() {
    this.channel?.close();
    this.channel_name = null;
    this.channel = null;
  }

  ngOnDestroy() {
    this.close();
  }
}
